import { Meta } from '@/components/common';
import { SettingsCards } from '@/components/features/settings/SettingsCards';
import { Container } from '@/components/layout';

/**
 * Settings - the Settings item in the sidebar. Kept at ROUTES.security so
 * existing links still land here.
 */
export function SecurityPage() {
  return (
    <>
      <Meta title="Settings" />

      <Container>
        <SettingsCards />
      </Container>
    </>
  );
}
